import { getRecordType } from '@xbcb/core';
import { validateAgentForDeliveryOrder } from '@xbcb/work-order-utils/dist/validateAgentForDeliveryOrder';
import {
  getOneQuery,
  getRecordName,
  getRecordFromResponse,
} from '@xbcb/shared-queries';
import { client as apolloClient } from '@xbcb/apollo-client';
import { AppRecordValidateUpdate } from '../routes';
import { getValidationParams } from './getValidationParams';

// TODO There is a lot of duplication of logic here and individual forms. Try to abstract the logic for required fields
const validateDeliveryOrder: AppRecordValidateUpdate = async ({
  input,
  existingRecord,
}) => {
  const { validateFields, additionalErrors } = getValidationParams({
    input,
  });

  const agentId =
    existingRecord.group?.forwarders?.[0]?.forwarder?.id ||
    existingRecord.group?.customsBroker?.id;
  const queryFields = `
  id
  version
  name
  email 
  phone {
    country
    number
    extension
  }
  addresses {
    mailing {
      address
      city
      postalCode
      stateCode
      countryCode
    }
    physical {
      address
      city
      postalCode
      stateCode
      countryCode
    }
  }`;
  const recordName = getRecordType(agentId);
  if (!recordName) {
    additionalErrors.push({
      title: 'Unknown Agent Type',
      messages: ['Agent not found for delivery order please check'],
    });
    return {
      additionalErrors,
      validateFields,
    };
  }

  const recordNameCamel = getRecordName(recordName, 'camel');
  const query = getOneQuery({
    recordName,
    fields: queryFields,
  });
  const response = await apolloClient.query({
    query,
    variables: { id: agentId },
  });
  const data = getRecordFromResponse(response, 'get', recordName);
  const agentErrors = validateAgentForDeliveryOrder(data);
  if (agentErrors.length) {
    additionalErrors.push({ title: 'Agent Errors', messages: agentErrors });
  }
  return {
    additionalErrors,
    validateFields,
  };
};

export default validateDeliveryOrder;
